import en from './enImports'
import es from './esImports'

const messages = {
  en,
  es
}

export default messages
